import { OBSTypesEnum, PriceBasisEnum } from '@msc-b2c/interfaces/enums';
import { OBSObjI } from '@msc-b2c/interfaces/types';

/**
 * Checks if the OBS card is priced per cabin.
 * It uses the array perPersonPriceBasisCodes to check forced PER_PERSON price basis.
 *
 * @param obsCard - The OBS card object to check.
 * @returns {boolean} - Returns true if the OBS card is priced per cabin, false otherwise.
 */
export function isOBSPriceBasisPerCabin(obsCard: OBSObjI | null): boolean {
  const perPersonPriceBasisCodes = [OBSTypesEnum.PHOTO.toString(), OBSTypesEnum.LAUNDR.toString()];
  if (
    perPersonPriceBasisCodes.includes(obsCard?.type.code ?? '') ||
    obsCard?.prepaidItems?.isPerCouple
  ) {
    return false;
  }

  return obsCard?.priceBasis === PriceBasisEnum.PER_CABIN;
}
